interface LoadingProps {
    loading: boolean;
    onClose: () => void;
}

// 로딩 컴포넌트
export function Loading({loading, onClose}: LoadingProps) {
    if (!loading) return null;

    return (
        <div className="loading-wrap">
            <button className="loading-close-btn" onClick={onClose}>
                X
            </button>
            <div className="loading-box">
                <div className="loadingio-spinner-spin-dxynu7pmxp">
                    <div className="ldio-yo2l5f2gl2">
                        <div>
                            <div></div>
                        </div>
                        <div>
                            <div></div>
                        </div>
                        <div>
                            <div></div>
                        </div>
                        <div>
                            <div></div>
                        </div>
                        <div>
                            <div></div>
                        </div>
                        <div>
                            <div></div>
                        </div>
                        <div>
                            <div></div>
                        </div>
                        <div>
                            <div></div>
                        </div>
                    </div>
                </div>
                <p className="loading-text"><span>진행 중입니다.</span><br/>잠시만 기다려 주세요.</p>
            </div>
        </div>
    );
}